// extracted by css-extract-rspack-plugin
export default {"Modal":"Modal-FStyDu","modal":"Modal-FStyDu"};